<template>
    <div class="food-category-section">
      <br>
        <v-divider></v-divider>
         <v-text-field
           :label=this.meal.category
            disabled
            single-line
            full-width
            hide-details
         >
         </v-text-field>
        <div class="food-category-section-items">
            <food-item v-for="food in this.meal.data" :key="food.title" :food.sync="food" v-on:clicked="removeFood"></food-item>
            <v-btn class="food-category-section-add" v-on:click="addFood" fab dark color="grey lighten-1">
              <v-icon>add</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
import FoodItem from "./FoodItem.vue";

export default {
  name: "FoodCategory",
  components: {
    FoodItem
  },
  props: {
    meal: {
      type: Object
    }
  },
  data: function() {
    return {
      items: []
    };
  },
  methods: {
    addFood: function() {
      let tempTitle = this.meal.category + " 메뉴" + this.meal.data.length;
      this.meal.data.push({ title: tempTitle, items: [] });
    },
    removeFood: function(food) {
      this.meal.data.splice(this.meal.data.indexOf(food), 1);
    }
  }
};
</script>

<style scoped>
.food-category-section-items {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* justify-content: flex-start; */
  /* align-items: center; */
  height: 100;
  padding-right: 10px;
  margin-right: 20px;
}
.food-category-section-add {
  margin-left: 50px;
  align-self: center;
}
</style>